import { Injectable, Inject, HostListener } from '@angular/core';
import { WINDOW } from '../window/window.service';
import { DOCUMENT } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  public isSolid = false;

  private solidBg = new BehaviorSubject<any>({});
  bg = this.solidBg.asObservable();
  private changeAbleHeader = new BehaviorSubject<any>({});
  headerScroll = this.changeAbleHeader.asObservable();
  private mainNav = new BehaviorSubject<any>({});
  nav = this.mainNav.asObservable();
  private noHeader = new BehaviorSubject<any>({});
  noheader = this.noHeader.asObservable();
  private isTripHeader = new BehaviorSubject<any>({});
  istripheader = this.isTripHeader.asObservable();
  public HeaderTitle = new BehaviorSubject<string>('');
  public headerTitle = this.HeaderTitle.asObservable();
  public SecondaryHeaderTitle = new BehaviorSubject<string>('');
  public secondaryHeaderTitle = this.SecondaryHeaderTitle.asObservable();
  private HeaderClass = new BehaviorSubject<string>('');
  public headerClass = this.HeaderClass.asObservable();
  private luckyCountBS = new BehaviorSubject<any>(0);
  luckyCountObs = this.isTripHeader.asObservable();

  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(WINDOW) private window
  ) { }

  isSolidBg(res) {
    this.solidBg.next(res);
  }

  headerBGChangeAble(param) {
    this.changeAbleHeader.next(param);
  }

  showMainNav(b) {
    this.mainNav.next(b);
  }

  hasNoHeader(b) {
    this.noHeader.next(b);
  }

  tripHeader(state) {
    this.isTripHeader.next(state);
  }

  title(title) {
    this.HeaderTitle.next(title);
  }

  secondTitle(title) {
    this.SecondaryHeaderTitle.next(title);
  }

  class(htmlClass) {
    this.HeaderClass.next(htmlClass);
  }

  luckyCount(count) {
    this.luckyCountBS.next(count);
  }
}
